// extracted by mini-css-extract-plugin
export default {"container":"homeProductSlider_container__2t-nQ","title":"homeProductSlider_title__TC7mE"};